// users can define a shared main host which all services
// live on...
const SHARED_HOST = process.env.REACT_APP_HOST || window.location.hostname;
const HERMES_HOST = process.env.REACT_APP_HERMES_HOST || SHARED_HOST;
const HERMES_PORT = process.env.REACT_APP_HERMES_PORT || 8890;
const API_HOST = process.env.REACT_APP_API_HOST || SHARED_HOST;
const API_PORT = process.env.REACT_APP_API_PORT || 8889;
const UNICORN_HOST = process.env.REACT_APP_UNICORN_HOST || SHARED_HOST;
const UNICORN_PORT = process.env.REACT_APP_UNICORN_PORT || 8891;
const USE_HTTPS = window.location.protocol === 'https:';
const HTTP_PROTOCOL = USE_HTTPS ? 'https' : 'http';
const WS_PROTOCOL = USE_HTTPS ? 'wss' : 'ws';

function normalizeBaseUrl(url: unknown): string | null {
  if (typeof url !== 'string') return null;
  let s = url.trim();
  if (!s) return null;

  while (
    (s.startsWith('`') && s.endsWith('`')) ||
    (s.startsWith('"') && s.endsWith('"')) ||
    (s.startsWith("'") && s.endsWith("'"))
  ) {
    s = s.slice(1, -1).trim();
  }

  if (s.includes('`')) s = s.replace(/`/g, '').trim();
  if (!s) return null;

  return s.endsWith('/') ? s.slice(0, -1) : s;
}

function withOptionalPort(protocol: string, host: string, port: unknown): string {
  const portStr = typeof port === 'number' ? String(port) : typeof port === 'string' ? port.trim() : '';
  if (!portStr) return `${protocol}://${host}`;
  const portNum = Number(portStr);
  const isDefaultPort = Number.isFinite(portNum) && ((protocol === 'https' && portNum === 443) || (protocol === 'http' && portNum === 80));
  return isDefaultPort ? `${protocol}://${host}` : `${protocol}://${host}:${portStr}`;
}

export function getServices() {
  const apiUrlOverride = normalizeBaseUrl((process.env as any).REACT_APP_API_URL || (process.env as any).NEXT_PUBLIC_API_URL);
  const hermesWsOverride = normalizeBaseUrl((process.env as any).REACT_APP_HERMES_WS_URL || (process.env as any).NEXT_PUBLIC_HERMES_WS_URL);
  const hermesHttpOverride = normalizeBaseUrl((process.env as any).REACT_APP_HERMES_HTTP_URL || (process.env as any).NEXT_PUBLIC_HERMES_HTTP_URL);
  const unicornWsOverride = normalizeBaseUrl((process.env as any).REACT_APP_UNICORN_WS_URL || (process.env as any).NEXT_PUBLIC_UNICORN_WS_URL);
  const unicornHttpOverride = normalizeBaseUrl((process.env as any).REACT_APP_UNICORN_HTTP_URL || (process.env as any).NEXT_PUBLIC_UNICORN_HTTP_URL);
  const apiHttp = (() => {
    const defaultApiHttp = USE_HTTPS ? window.location.origin : withOptionalPort(HTTP_PROTOCOL, API_HOST, API_PORT);
    if (!apiUrlOverride) return defaultApiHttp;
    if (!USE_HTTPS) return apiUrlOverride;
    try {
      const overrideOrigin = new URL(apiUrlOverride).origin;
      return overrideOrigin === window.location.origin ? apiUrlOverride : window.location.origin;
    } catch {
      return window.location.origin;
    }
  })();

  return {
    hermes: {
      http: hermesHttpOverride || withOptionalPort(HTTP_PROTOCOL, HERMES_HOST, HERMES_PORT),
      ws: hermesWsOverride || (USE_HTTPS ? `${WS_PROTOCOL}://${window.location.host}/hermes` : withOptionalPort(WS_PROTOCOL, HERMES_HOST, HERMES_PORT)),
    },
    api: {
      http: apiHttp,
    },
    unicorn: {
      http: unicornHttpOverride || withOptionalPort(HTTP_PROTOCOL, UNICORN_HOST, UNICORN_PORT),
      ws: unicornWsOverride || (USE_HTTPS ? `${WS_PROTOCOL}://${window.location.host}/unicorn` : withOptionalPort(WS_PROTOCOL, UNICORN_HOST, UNICORN_PORT)),
    },
  };
}
